var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import Title from 'components/shared/Title';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import AdminIntroduceModifier from './Modifier';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n  overflow: auto;\n\n  > .title {\n    width: 100%;\n    height: 85px;\n    margin-bottom: 50px;\n  }\n\n  > h2 {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n  overflow: auto;\n\n  > .title {\n    width: 100%;\n    height: 85px;\n    margin-bottom: 50px;\n  }\n\n  > h2 {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n"])));
export var GET_INTRODUCE = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query Project($projectName: String!) {\n    project(projectName: $projectName) {\n      id\n      introduce {\n        bgUrl\n        title\n        content\n      }\n    }\n  }\n"], ["\n  query Project($projectName: String!) {\n    project(projectName: $projectName) {\n      id\n      introduce {\n        bgUrl\n        title\n        content\n      }\n    }\n  }\n"])));
export default (function (_a) {
    var project = _a.project;
    return (React.createElement(Query, { query: GET_INTRODUCE, variables: { projectName: project } }, function (_a) {
        var loading = _a.loading, error = _a.error, data = _a.data, client = _a.client;
        if (loading)
            return React.createElement(Loading, null);
        if (error || !data.project)
            return React.createElement(Error, { error: error });
        return (React.createElement(Container, null,
            React.createElement("div", { className: "title" },
                React.createElement(Title, { title: "\uD68C\uC0AC\uC18C\uAC1C" })),
            React.createElement(AdminIntroduceModifier, { introduce: data.project.introduce, client: client, project: project })));
    }));
});
var templateObject_1, templateObject_2;
